import {InjectionToken} from '@angular/core';
import {algoliasearch} from 'algoliasearch';

export const ALGOLIA_TOKEN = new InjectionToken('ALGOLIA_TOKEN', {
  providedIn: 'root',
  factory: () => algoliasearch,
});
